import { LitElement, TemplateResult, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("sb-preview")
export class PreviewComponent extends LitElement {
  @property({ type: Boolean }) loading = false;
  @property({ type: Object }) renderSpec: TemplateResult | null = null;

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this; // use light DOM so shadcn/Tailwind styles apply
  }

  render() {
    return html`
      ${this.loading
        ? html`<div class="sb-p-8 sb-text-center">Loading...</div>`
        : html`
            <sb-provider>
              <signed-out>
                <sb-layout .renderSpec=${this.renderSpec}> </sb-layout>
              </signed-out>
            </sb-provider>
          `}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "sb-preview": PreviewComponent;
  }
}
